import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '@iarcpsu/emanufac-components/src/components/Button';
import { PaymentTypeForm } from '@iarcpsu/emanufac-components/src/components/Forms';
import { Loading } from '@iarcpsu/emanufac-components/src/components/Loading';
import { Error } from '@iarcpsu/emanufac-components/src/components/Error';
import { ViewTitle } from '@iarcpsu/emanufac-components/src/components/ViewTitle';

export default function EditPaymentType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const paymentType = useSelector((state) => state.paymentType);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      type_code: paymentType.type_code,
      name: paymentType.name,
      detail: paymentType.detail,
    },
  });

  useEffect(() => {
    dispatch(actions.paymentTypeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      // eslint-disable-next-line no-param-reassign
      console.log(data);
      await dispatch(actions.paymentTypePut(id, data));
      alert('สำเร็จ');
      await dispatch(actions.paymentTypeGet(id));
    } catch (error) {
      console.log(error);
    }
  };
  if (paymentType.isLoading || paymentType.rows) {
    return <Loading />;
  }
  if (!paymentType.isLoading && paymentType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-6">
            <form onSubmit={handleSubmit(onSubmit)}>
              <PaymentTypeForm
                control={control}
                Controller={Controller}
                errors={errors}
                paymentType={paymentType}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditPaymentType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditPaymentType.defaultProps = {
  title: '',
  subtitle: '',
};
